"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsActiveAlertPage = void 0;
var _react = _interopRequireDefault(require("react"));
var _dmsbasereact = require("dmsbasereact");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
var _ActiveAlertTable = require("./DmsAlertComponents/ActiveAlertTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsActiveAlertPage = () => {
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsPage, {
    name: "Active Alerts"
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("AlertComponents").d("Alert Components"))), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_ActiveAlertTable.DmsActiveAlertTable, null))));
};
exports.DmsActiveAlertPage = DmsActiveAlertPage;